import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import React from 'react'

const AccessModal = ({ isOpen, onClose, text, handleSubmit }) => {

  return (
    <Modal isOpen={isOpen} size={'sm'} onClose={onClose}>
        <ModalContent className='py-4'>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 text-center">Are you sure?</ModalHeader>
              <ModalBody className='text-center'>
                <p>Do you want to <span className='lowercase'>{text}</span> this user?</p>
              </ModalBody> 
              <ModalFooter className='grid grid-cols-2 px-16 mt-5'>
                <Button className='text-red-600 border-2 border-red-600' variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button className={`${text === 'Reject' ? 'bg-red-700' : 'bg-green-700'} text-white font-medium`} onPress={handleSubmit}>
                  {text}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
  )
}

export default AccessModal